// Компонент пошукової панелі.
// Основне:
// - Керує сабмітом форми, валідує поле (не порожнє).
// - Викликає onSubmit(query) для пошуку фільмів.
// - Показує зовнішнє посилання на TMDB, містить інпут та кнопку.
import toast from "react-hot-toast";
import styles from "./SearchBar.module.css";

interface SearchBarProps {
    onSubmit: (query: string) => void;
}

const SearchBar = ({ onSubmit }: SearchBarProps) => {
    // Ця функція буде викликана атрибутом `action`
    const handleFormAction = (formData: FormData) => {
        const query = formData.get("query") as string;

        if (query.trim() === "") {
            toast.error("Please enter your search query.");
            return;
        }

        onSubmit(query);
    };

    return (
        <header className={styles.header}>
            <div className={styles.container}>
                <a
                    className={styles.link}
                    href="https://www.themoviedb.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Powered by TMDB
                </a>
                {/* Використовуємо `action` замість `onSubmit` */}
                <form className={styles.form} action={handleFormAction}>
                    <input
                        className={styles.input}
                        type="text"
                        name="query"
                        autoComplete="off"
                        placeholder="Search movies..."
                        autoFocus
                    />
                    <button className={styles.button} type="submit">
                        Search
                    </button>
                </form>
            </div>
        </header>
    );
};

export default SearchBar;
